import React, {
    useCallback, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { InputField, DropdownSelectField, RadioButtonField, ToggleField, Icon } from '@jutro/legacy/components';
import { Currency as CurrencyField } from 'gw-components-platform-react';
import { Link } from '@jutro/router';
import styles from './OilandGasContractsComponent.module.scss';
import metadata from './OilandGasContractsComponent.metadata.json5';
import { TranslatorContext } from '@jutro/legacy/locale';

function OilandGasContractsComponent(props) {

    const {
        data: OilandGasContractsVM,
        updateWizardData,
        submissionVM,
        OilandGasContractsPath
    } = props;
    const translator = useContext(TranslatorContext);
    const viewModelService = useContext(ViewModelServiceContext);


    const addOilandGasContracts = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            OilandGasContractsVM.value = OilandGasContractsVM.value || []

            const { _xCenter, _dtoName } = OilandGasContractsVM;

            const OilandGasContractsObjVM = viewModelService.create(
                {},
                _xCenter,
                _dtoName
            );

            OilandGasContractsVM.pushElement(
                OilandGasContractsObjVM
            );
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData, OilandGasContractsVM, viewModelService]
    );


    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );


    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            OilandGasContractsVM.value.splice(index, 1);
            _.set(submissionVM.value, OilandGasContractsPath, OilandGasContractsVM.value);
            updateWizardData(submissionVM);
        }, [submissionVM, updateWizardData, OilandGasContractsPath, OilandGasContractsVM?.value]
    );


    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow
        (item, index, props) => {
            const { path } = props;

            if (path === 'oilGasConInThePas51') {
                const value = (item && item.oilGasConInThePas51) ? item.oilGasConInThePas51 : undefined;
                // eslint-disable-next-line security/detect-object-injection
                const availableValues = OilandGasContractsVM.length > 0 && OilandGasContractsVM.children[index].oilGasConInThePas51
                    // eslint-disable-next-line security/detect-object-injection
                    ? OilandGasContractsVM.children[index].oilGasConInThePas51.aspects.availableValues
                        .map((typeCode) => ({
                            code: typeCode.code,
                            name: translator({
                                id: typeCode.name,
                                defaultMessage: typeCode.name
                            })
                        }))
                    : [];

                return (
                    <DropdownSelectField
                        id={index + path}
                        className={styles.coverageForm}
                        onValueChange={(val, changedPath) => {
                            item.oilGasConInThePas51 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        dataType="string"
                        path={path}
                        value={value}
                        availableValues={availableValues}
                        searchable
                    />
                );
            }

            if (path === 'desOfSerPer2') {
                const value = item.desOfSerPer2 ? item.desOfSerPer2 : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.desOfSerPer2 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'conVal3') {
                const value = item.conVal3 ? item.conVal3 : { amount: 0, currency: 'cad' };

                return (
                    <CurrencyField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="object"
                        onValueChange={(val, changedPath) => {
                            if(val.amount === '-' || val.amount < 0) return;
                            item.conVal3 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'proFee4') {
                const value = item.proFee4 ? item.proFee4 : { amount: 0, currency: 'cad' };

                return (
                    <CurrencyField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="object"
                        onValueChange={(val, changedPath) => {
                            if(val.amount === '-' || val.amount < 0) return;
                            item.proFee4 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'doeYouComOrAnyRelCom5') {
                const value = item.doeYouComOrAnyRelCom5 !== undefined ? item.doeYouComOrAnyRelCom5 : false;

                return (
                    <ToggleField
                        availableValues={[
                            {
                                code: 'true',
                                name: 'Yes'
                            },
                            {
                                code: 'false',
                                name: 'No'
                            }
                        ]}
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        onValueChange={(val, changedPath) => {
                            item.doeYouComOrAnyRelCom5 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'doTheActAsARepFor6') {
                const value = item.doTheActAsARepFor6 !== undefined ? item.doTheActAsARepFor6 : false;

                return (
                    <ToggleField
                        availableValues={[
                            {
                                code: 'true',
                                name: 'Yes'
                            },
                            {
                                code: 'false',
                                name: 'No'
                            }
                        ]}
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        onValueChange={(val, changedPath) => {
                            item.doTheActAsARepFor6 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'ifYesPleProDetExp7' && !((_.isUndefined(item.doeYouComOrAnyRelCom5) || item.doeYouComOrAnyRelCom5 === false)
                            && (_.isUndefined(item.doTheActAsARepFor6) || item.doTheActAsARepFor6 === false))) {
                const value = item.ifYesPleProDetExp7 ? item.ifYesPleProDetExp7 : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.ifYesPleProDetExp7 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }


        }, [handleValueChange, translator, OilandGasContractsVM])

    const removeAssignmentTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            (<Link
                onClick={(e) => removeAssignmentItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>)
        ),
        [removeAssignmentItem]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`OilandGasContractsTable`]: {
            data: OilandGasContractsVM.value,
        },
        ifYesPleProDetExp7: {
            visible: (!_.isUndefined(OilandGasContractsVM.value.doeYouComOrAnyRelCom5) && OilandGasContractsVM.value.doeYouComOrAnyRelCom5) ||
                (!_.isUndefined(OilandGasContractsVM.value.doTheActAsARepFor6) && OilandGasContractsVM.value.doTheActAsARepFor6)
        }

    }), [OilandGasContractsVM?.value])

    const resolvers = {
        resolveCallbackMap: {
            addOilandGasContracts,
            getTableCell,
            removeAssignmentTableRow
        }
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            OilandGasContractsVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [OilandGasContractsVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={OilandGasContractsVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

OilandGasContractsComponent.propTypes = wizardProps;
export default withRouter(OilandGasContractsComponent);
